var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPayment2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.63 26.4228C37.5935 20.0854 45.0205 14.4381 52.8296 9.54279C54.9348 7.92543 57.3014 6.80094 59.7915 6.23484C62.6375 5.97269 65.4851 6.70948 67.9509 8.34602C67.9509 8.34602 68.05 8.34641 68.078 8.44321C68.7418 8.81648 69.3914 9.23802 70.0409 9.67569C77.1003 14.538 83.3163 21.653 85.9304 30.5907C86.4007 32.2329 86.7543 33.9156 86.9876 35.6225C87.6092 40.5554 87.3159 45.5824 86.1267 50.3797C84.4582 56.8549 81.5991 62.8528 77.7393 67.9753C73.2226 74.4563 67.1298 79.2802 60.2217 81.8445C57.5241 82.7718 54.725 83.2598 51.9078 83.2939C43.4147 83.3891 34.836 79.842 27.3089 75.139C25.8526 74.2527 24.4387 73.2788 23.0733 72.2216C20.5651 70.4069 18.3675 68.0886 16.5873 65.3795C8.14535 51.5682 21.7804 34.9604 30.63 26.4228Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9087 11.8926C57.6987 9.96525 67.0888 12.6178 74.0876 18.3502C76.9194 20.6681 79.3681 23.4951 81.2167 26.7046C85.3325 33.8473 86.6523 42.5075 85.6442 50.7516C84.6362 58.9956 81.4043 66.8426 77.0218 73.814C73.6642 79.1542 69.5515 84.0975 64.3873 87.5792C59.2231 91.0609 52.9206 92.9914 46.8151 92.0806C41.5206 91.2914 36.6852 88.4452 32.5802 84.9059C23.5111 77.086 17.5358 65.6068 16.0129 53.5113C14.8281 44.1003 16.4456 33.9754 22.1386 26.5253C28.4333 18.2877 38.5089 14.5243 48.0557 12.0943C48.3395 12.0223 48.6233 11.955 48.9087 11.8926Z",
    fill: "#2CBA94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.244 44.8047C64.8985 38.1109 73.0437 35.6406 76.5345 35.2422C85.8437 37.6328 62.5709 66.3202 48.6077 75.8827C34.6444 85.4451 24.1722 67.5155 23.0086 55.5624C21.845 43.6093 38.1355 54.3671 40.4627 62.7343C42.7899 71.1014 54.426 53.1718 60.244 44.8047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9899 59.289C18.563 47.5861 34.3626 53.0195 38.7141 59.289C43.0656 65.5586 40.12 67.3698 45.7435 62.0756C52.773 55.4579 73.8615 30.3804 76.874 36.6496C79.8865 42.9188 45.7435 72.8727 42.7309 74.2662C39.7183 75.6597 31.4168 70.992 24.9899 59.289Z",
    stroke: "#393B46",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4442 14.8516C26.2726 15.3654 9.513 33.4991 10.0108 55.3529C10.4916 76.4849 26.9736 93.4964 47.4458 93.9942C68.619 93.9942 90 71.8458 90 50.0688C89.9814 29.987 70.663 14.8516 47.4442 14.8516Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPayment2);
export default __webpack_public_path__ + "static/media/success-payment-2.879a1b037fac30df1e185e3447fd419e.svg";
export { ForwardRef as ReactComponent };